<template>
  <template v-if="getShow">
    <section class="flex flex-col items-center">
      <SvgIcon name="success" size="49" />
      <h1 class="mt-5 mb-4 text-2xl font-bold">{{ t('sys.login.resetPasswordSuccess') }}</h1>
      <p>{{ t('sys.login.goLogin5second') }}</p>
      <Button class="mt-10" type="primary" size="large" block @click="btnHandleBackLogin">
        {{ t('common.confirm') }}
      </Button>
    </section>
  </template>
</template>
<script lang="ts" setup>
  import { computed, ref, unref, watchEffect } from 'vue';
  import { Button } from 'ant-design-vue';
  import { useI18n } from '@mcex/locale';
  import { SvgIcon } from '/@/components/Icon';
  import { ForgetPassStateEnum, useForgetPassState, useLoginState } from './useLogin';
  const { t } = useI18n();
  const { handleBackLogin } = useLoginState();
  const { getForgetPassState } = useForgetPassState();
  const getShow = computed(() => unref(getForgetPassState) === ForgetPassStateEnum.SUCCESS);

  // 定时器句柄
  const backLoginTimer = ref();

  const btnHandleBackLogin = () => {
    // 清除定时器，防止二次跳转
    backLoginTimer.value && clearTimeout(backLoginTimer.value);
    handleBackLogin();
  };

  watchEffect(() => {
    if (getShow.value) {
      backLoginTimer.value = setTimeout(() => {
        handleBackLogin();
      }, 5000);
    }
  });
</script>
<style lang="less" scoped>
  @link-cls: ~'@{namespace}-link';
  .@{link-cls} {
    color: @other-link-color;
  }
</style>
